<template>
  <header>
    <MagicMenu/>
  </header>
</template>
<script>
import MagicMenu from '@/components/magic-menu/MagicMenu.vue'
export default {
  name: 'MagicLayoutHeader',
  components: {
    MagicMenu
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/magic-layout/MagicLayoutHeader.vue